export interface MenuItem {
    title: string;
    icon: string;
    link?: string;
    section?: string;
    permissions?: string[];
    external?: boolean;
    children?: ChildMenuItem[];
    hideForSubAgent?: boolean;
    // NEOIQ-2427: "Find Super Agent" is visible only to Regular Agents (is_super_agent = false).
    hideForSuperAgent?: boolean;
    // NEOIQ-2427: when set, clicking this item opens a SidePanelService dialog instead of routing
    // via `link` — see side-nav.component.ts#openPanelItem(). The id is resolved to a lazily
    // imported component so unrelated tenants don't pay for its bundle weight (e.g. Google Maps).
    panelId?: string;
    // NEOIQ-2427: when set, `icon` is rendered as a built-in Material Icons font glyph
    // (mat-icon's fontIcon) instead of a custom registered SVG (mat-icon's svgIcon) — the
    // default for every other item in this list, which all use branded SVGs from app.assests.ts.
    useFontIcon?: boolean;
}

interface ChildMenuItem {
    title: string;
    link: string;
    permissions?: string[];
}
